module.exports = __webpack_public_path__ + "static/scale-model-of-new-orleans-louisiana-5b58eae94be13b3fcffbaf5b44c8f8f6.png";